import React from 'react'
import HomeScreen from './pages/HomeScreen.jsx'
import AppLayout from './layouts/AppLayout.jsx'


const Acceuil = () => {
   
    return (
        <>
            <AppLayout>
                 <HomeScreen />
            </AppLayout>
            
        </>        
    )
}

export default Acceuil